import React from 'react';

import {isEqual} from 'lodash';
import PropTypes from 'prop-types';
import Select from 'react-select';

import * as APPSTYLE from '@/constants/pcConstAppStyle';

import 'react-select/dist/react-select.css';

import './SelectField.less';

class SelectField extends React.Component {
  shouldComponentUpdate(nextProps) {
    const {label, value, onChange, unit, fullWidthInput, options, styleCustom} = this.props;
    if (label !== nextProps.label) return true;
    if (value !== nextProps.value) return true;
    if (onChange !== nextProps.onChange) return true;
    if (unit !== nextProps.unit) return true;
    if (fullWidthInput !== nextProps.fullWidthInput) return true;
    if (isEqual(options, nextProps.options) !== true) return true;
    if (styleCustom !== nextProps.styleCustom) return true;
    return false;
  }

  render() {
    const {label, value, onChange, unit, fullWidthInput, options, styleCustom, disabled} = this.props;
    const classLabelColumn = fullWidthInput ? APPSTYLE.COLUMN_LABEL_FULL_WIDTH : APPSTYLE.COLUMN_LABEL_NORMAL;
    // eslint-disable-next-line no-nested-ternary
    const classInputCollumn = fullWidthInput
      ? unit === undefined
        ? APPSTYLE.COLUMN_INPUT_FULL_WIDTH_NO_UNIT
        : APPSTYLE.COLUMN_INPUT_FULL_WIDTH_UNIT
      : unit === undefined
      ? APPSTYLE.COLUMN_INPUT_NORMAL_NO_UNIT
      : APPSTYLE.COLUMN_INPUT_NORMAL_UNIT;
    const styleAdvSetup = styleCustom === undefined ? {top: 'auto', bottom: '100%', maxHeight: '600px'} : styleCustom;
    return (
      <div className="middleAlign">
        <div className={classLabelColumn}>
          <div className="row row-margin">
            <span
              className="spanStyleInputField"
              disabled={disabled}
            >
              {' '}
              {label}{' '}
            </span>
          </div>
        </div>
        <div className={`${classInputCollumn} col-select`}>
          {
            <Select
              id={label}
              name="form-field-name"
              options={options}
              className="selectField"
              value={value}
              onChange={onChange}
              clearable={false}
              searchable={false}
              placeholder=""
              // set selector to up
              menuContainerStyle={styleAdvSetup}
              isOptionDisabled={(option) => option.isdisabled}
            />
          }
        </div>
        <div className={APPSTYLE.COLUMN_UNIT}>
          <span className="spanStyleInputField unit"> {unit} </span>
        </div>
      </div>
    );
  }
}

SelectField.propTypes = {
  label: PropTypes.string,
  disabled: PropTypes.bool,
  value: PropTypes.any,
  onChange: PropTypes.func,
  unit: PropTypes.string,
  fullWidthInput: PropTypes.bool,
  options: PropTypes.array,
  styleCustom: PropTypes.object,
};

SelectField.defaultProps = {
  label: '',
  disabled: false,
  value: null,
  onChange: () => {},
  unit: '',
  fullWidthInput: false,
  options: [],
  styleCustom: null,
};

export default SelectField;
